import { UserPatient } from '../services/api/user/userApi';
import { Patient } from '../types';

export const dummyPatients: Partial<UserPatient[] | Patient[]> = [
  {
    id: '1',
    name: 'Maria Elena Rodriguez',
    phone: '+1 (555) 123-4567',
    email: 'maria.rodriguez@email.com',
    dateOfBirth: '1985-03-15',
    address: '123 Main St, Austin, TX 78701',
    insurance: {
      provider: 'Delta Dental',
      policyNumber: 'DD12345678',
      groupNumber: 'GRP001'
    },
    medicalHistory: ['Diabetes Type 2', 'Hypertension'],
    allergies: ['Penicillin'],
    lastVisit: '2024-12-01',
    nextAppointment: '2025-01-15',
    emergencyContact: {
      name: 'Carlos Rodriguez',
      phone: '+1 (555) 123-4568',
      relationship: 'Spouse'
    },
    language: 'es',
    notes: 'Prefers morning appointments. Anxious about dental procedures.',
    treatmentPlans: [
      {
        id: 'tp-1',
        title: 'Comprehensive Periodontal Treatment',
        description: 'Deep cleaning and gum disease treatment due to diabetes complications',
        status: 'accepted',
        // caseAcceptanceScore: 85,
        dateCreated: '2024-11-20',
        dateUpdated: '2024-12-01',
        procedures: [
          {
            id: 'proc-1',
            name: 'Scaling and Root Planing',
            duration: 90,
            priority: 'high'
          },
          {
            id: 'proc-2',
            name: 'Antibiotic Therapy',
            duration: 30,
            priority: 'medium'
          }
        ]
      }
    ],
    smsLogs: [
      {
        id: 'sms-1',
        date: '2025-01-14',
        direction: 'outbound',
        content: 'Recordatorio: Su cita es mañana a las 9:00 AM. Por favor confirme.',
        status: 'delivered'
      },
      {
        id: 'sms-2',
        date: '2025-01-14',
        direction: 'inbound',
        content: 'Sí, confirmado. Gracias.',
        status: 'delivered'
      }
    ],
    emailLogs: [
      {
        id: 'email-1',
        date: '2024-12-15',
        direction: 'outbound',
        subject: 'Instrucciones post-tratamiento',
        content: 'Estimada María, adjunto encontrará las instrucciones de cuidado...',
        status: 'opened'
      }
    ],
    dentalChart: {
      id: 'chart-1',
      lastUpdated: '2024-12-01',
      notes: 'Generalized gingivitis, especially around molars. Diabetes-related complications noted.',
      teeth: [
        {
          number: '1',
          condition: 'healthy',
          notes: 'Good condition',
          lastExamined: '2024-12-01'
        },
        {
          number: '14',
          condition: 'cavity',
          notes: 'Small cavity detected, needs filling',
          lastExamined: '2024-12-01'
        },
        {
          number: '19',
          condition: 'filling',
          notes: 'Amalgam filling in good condition',
          lastExamined: '2024-12-01'
        }
      ]
    },
    voiceToChartingNotes: [
      {
        id: 'vtc-1',
        date: '2024-12-01',
        callId: '1',
        transcription: 'Patient reports severe pain in lower right molar, difficulty chewing',
        extractedFindings: ['Pain in tooth #30', 'Difficulty chewing', 'Possible infection'],
        confidence: 0.92
      }
    ],
    predictiveTreatmentSuggestions: [
      {
        id: 'pts-1',
        suggestion: 'Consider antibiotic premedication for future procedures',
        reasoning: 'Patient has diabetes and history of slow healing',
        confidence: 0.88,
        priority: 'high',
        dateGenerated: '2024-12-01'
      }
    ],
    educationHistory: [
      {
        id: 'edu-1',
        title: 'Diabetes and Oral Health',
        type: 'video',
        url: 'https://example.com/diabetes-oral-health',
        dateSent: '2024-11-20',
        status: 'viewed',
        viewDuration: 180
      },
      {
        id: 'edu-2',
        title: 'Post-Treatment Care Instructions',
        type: 'pdf',
        url: 'https://example.com/post-care.pdf',
        dateSent: '2024-12-01',
        status: 'sent'
      }
    ],
    aiSuggestedMedicalAlerts: [
      {
        id: 'alert-1',
        alert: 'Patient mentioned increased thirst during call - monitor diabetes status',
        source: 'Call transcript analysis',
        confidence: 0.85,
        dateGenerated: '2024-12-01',
        status: 'pending'
      }
    ]
  },
  {
    id: '2',
    name: 'James Patterson',
    phone: '+1 (555) 234-5678',
    email: 'james.patterson@email.com',
    dateOfBirth: '1978-08-22',
    address: '456 Oak Ave, Austin, TX 78702',
    insurance: {
      provider: 'Cigna',
      policyNumber: 'CG87654321',
      groupNumber: 'GRP002'
    },
    medicalHistory: ['High Cholesterol'],
    allergies: [],
    lastVisit: '2024-11-20',
    emergencyContact: {
      name: 'Sarah Patterson',
      phone: '+1 (555) 234-5679',
      relationship: 'Wife'
    },
    language: 'en',
    notes: 'History of teeth grinding. Uses night guard.',
    treatmentPlans: [
      {
        id: 'tp-2',
        title: 'Night Guard Replacement and TMJ Evaluation',
        description: 'Replace damaged night guard and evaluate TMJ symptoms',
        status: 'completed',
        // caseAcceptanceScore: 95,
        dateCreated: '2024-10-15',
        dateUpdated: '2024-11-20',
        procedures: [
          {
            id: 'proc-3',
            name: 'Custom Night Guard',
            duration: 60,
            priority: 'high'
          },
          {
            id: 'proc-4',
            name: 'TMJ Evaluation',
            duration: 30,
            priority: 'medium'
          }
        ]
      }
    ],
    smsLogs: [
      {
        id: 'sms-3',
        date: '2025-01-13',
        direction: 'outbound',
        content: 'Your new night guard is ready for pickup. Please call to schedule.',
        status: 'delivered'
      }
    ],
    emailLogs: [
      {
        id: 'email-2',
        date: '2024-11-21',
        direction: 'outbound',
        subject: 'Night Guard Care Instructions',
        content: 'Dear James, here are the care instructions for your new night guard...',
        status: 'opened'
      }
    ],
    dentalChart: {
      id: 'chart-2',
      lastUpdated: '2024-11-20',
      notes: 'Evidence of bruxism. Wear patterns on molars. New night guard fitted.',
      teeth: [
        {
          number: '3',
          condition: 'healthy',
          notes: 'Slight wear from grinding',
          lastExamined: '2024-11-20'
        },
        {
          number: '30',
          condition: 'crown',
          notes: 'Porcelain crown in excellent condition',
          lastExamined: '2024-11-20'
        }
      ]
    },
    voiceToChartingNotes: [
      {
        id: 'vtc-2',
        date: '2024-11-20',
        callId: '2',
        transcription: 'Patient reports night guard is cracked and uncomfortable',
        extractedFindings: ['Night guard damaged', 'Discomfort during sleep', 'Possible TMJ symptoms'],
        confidence: 0.89
      }
    ],
    predictiveTreatmentSuggestions: [
      {
        id: 'pts-2',
        suggestion: 'Monitor for TMJ progression, consider bite adjustment',
        reasoning: 'Continued bruxism despite night guard use',
        confidence: 0.75,
        priority: 'medium',
        dateGenerated: '2024-11-20'
      }
    ],
    educationHistory: [
      {
        id: 'edu-3',
        title: 'Managing Teeth Grinding',
        type: 'video',
        url: 'https://example.com/bruxism-management',
        dateSent: '2024-10-15',
        status: 'completed',
        viewDuration: 240
      }
    ],
    aiSuggestedMedicalAlerts: []
  },
  {
    id: '3',
    name: 'Dr. Ashley Chen',
    phone: '+1 (555) 345-6789',
    email: 'ashley.chen@email.com',
    dateOfBirth: '1990-12-10',
    address: '789 Pine St, Austin, TX 78703',
    insurance: {
      provider: 'MetLife',
      policyNumber: 'ML11223344',
      groupNumber: 'GRP003'
    },
    medicalHistory: [],
    allergies: ['Latex'],
    lastVisit: '2024-10-15',
    nextAppointment: '2025-01-20',
    emergencyContact: {
      name: 'Michael Chen',
      phone: '+1 (555) 345-6790',
      relationship: 'Brother'
    },
    language: 'en',
    notes: 'Healthcare professional. Prefers detailed explanations.',
    treatmentPlans: [
      {
        id: 'tp-3',
        title: 'Root Canal Treatment - Tooth #14',
        description: 'Endodontic treatment for infected molar with latex-free protocols',
        status: 'in-progress',
        // caseAcceptanceScore: 98,
        dateCreated: '2024-10-01',
        dateUpdated: '2024-10-15',
        procedures: [
          {
            id: 'proc-5',
            name: 'Root Canal Therapy',
            toothNumber: '14',
            duration: 90,
            priority: 'high'
          },
          {
            id: 'proc-6',
            name: 'Crown Placement',
            toothNumber: '14',
            duration: 60,
            priority: 'high'
          }
        ]
      }
    ],
    smsLogs: [
      {
        id: 'sms-4',
        date: '2025-01-18',
        direction: 'outbound',
        content: 'Reminder: Root canal appointment on Jan 20th. All latex-free protocols confirmed.',
        status: 'delivered'
      }
    ],
    emailLogs: [
      {
        id: 'email-3',
        date: '2024-10-16',
        direction: 'outbound',
        subject: 'Latex-Free Protocol Confirmation',
        content: 'Dear Dr. Chen, as requested, here is the complete list of latex-free materials...',
        status: 'opened'
      }
    ],
    dentalChart: {
      id: 'chart-3',
      lastUpdated: '2024-10-15',
      notes: 'Tooth #14 requires endodontic treatment. Patient is healthcare professional, very informed.',
      teeth: [
        {
          number: '14',
          condition: 'cavity',
          notes: 'Deep caries, pulp involvement, needs RCT',
          lastExamined: '2024-10-15'
        }
      ]
    },
    voiceToChartingNotes: [
      {
        id: 'vtc-3',
        date: '2024-10-15',
        callId: '3',
        transcription: 'Patient reports sensitivity to cold and pressure in upper right molar',
        extractedFindings: ['Cold sensitivity tooth #14', 'Pressure pain', 'Possible pulpitis'],
        confidence: 0.94
      }
    ],
    predictiveTreatmentSuggestions: [
      {
        id: 'pts-3',
        suggestion: 'Consider immediate crown placement post-RCT to prevent fracture',
        reasoning: 'Healthcare professional with high stress levels, increased risk of bruxism',
        confidence: 0.82,
        priority: 'high',
        dateGenerated: '2024-10-15'
      }
    ],
    educationHistory: [
      {
        id: 'edu-4',
        title: 'Endodontic Treatment Process',
        type: 'pdf',
        url: 'https://example.com/rct-process.pdf',
        dateSent: '2024-10-01',
        status: 'viewed'
      }
    ],
    aiSuggestedMedicalAlerts: [
      {
        id: 'alert-2',
        alert: 'Patient mentioned work stress - monitor for bruxism signs',
        source: 'Call transcript analysis',
        confidence: 0.78,
        dateGenerated: '2024-10-15',
        status: 'reviewed',
        reviewedBy: 'Dr. Estrabillo'
      }
    ]
  },
  {
    id: '4',
    name: 'Roberto Gonzalez',
    phone: '+1 (555) 456-7890',
    email: 'roberto.gonzalez@email.com',
    dateOfBirth: '1965-05-30',
    address: '321 Cedar Ln, Austin, TX 78704',
    insurance: {
      provider: 'Guardian',
      policyNumber: 'GD55667788',
      groupNumber: 'GRP004'
    },
    medicalHistory: ['Heart Disease', 'Blood Thinner Medication'],
    allergies: ['Codeine'],
    lastVisit: '2024-09-10',
    emergencyContact: {
      name: 'Isabella Gonzalez',
      phone: '+1 (555) 456-7891',
      relationship: 'Daughter'
    },
    language: 'es',
    notes: 'Requires antibiotic premedication. Senior citizen discount applied.',
    treatmentPlans: [
      {
        id: 'tp-4',
        title: 'Cardiac Risk Management Protocol',
        description: 'Coordinated care with cardiologist for dental procedures',
        status: 'accepted',
        // caseAcceptanceScore: 90,
        dateCreated: '2024-08-15',
        dateUpdated: '2024-09-10',
        procedures: [
          {
            id: 'proc-7',
            name: 'Antibiotic Premedication',
            duration: 15,
            priority: 'high'
          },
          {
            id: 'proc-8',
            name: 'Routine Cleaning with Monitoring',
            duration: 75,
            priority: 'medium'
          }
        ]
      }
    ],
    smsLogs: [
      {
        id: 'sms-5',
        date: '2025-01-12',
        direction: 'outbound',
        content: 'Recordatorio: Coordinar con cardiólogo antes de su próxima cita.',
        status: 'delivered'
      }
    ],
    emailLogs: [],
    dentalChart: {
      id: 'chart-4',
      lastUpdated: '2024-09-10',
      notes: 'Patient requires cardiac risk assessment before procedures. Good oral hygiene.',
      teeth: [
        {
          number: '8',
          condition: 'healthy',
          notes: 'Good condition for age',
          lastExamined: '2024-09-10'
        }
      ]
    },
    voiceToChartingNotes: [],
    predictiveTreatmentSuggestions: [
      {
        id: 'pts-4',
        suggestion: 'Schedule shorter appointments to reduce cardiac stress',
        reasoning: 'Patient has heart disease and takes blood thinners',
        confidence: 0.91,
        priority: 'high',
        dateGenerated: '2024-09-10'
      }
    ],
    educationHistory: [
      {
        id: 'edu-5',
        title: 'Cuidado Dental para Pacientes Cardíacos',
        type: 'pdf',
        url: 'https://example.com/cardiac-dental-care-es.pdf',
        dateSent: '2024-08-15',
        status: 'viewed'
      }
    ],
    aiSuggestedMedicalAlerts: []
  },
  {
    id: '5',
    name: 'Jennifer Walsh',
    phone: '+1 (555) 567-8901',
    email: 'jennifer.walsh@email.com',
    dateOfBirth: '1992-11-18',
    address: '654 Maple Dr, Austin, TX 78705',
    insurance: {
      provider: 'Aetna',
      policyNumber: 'AE99887766',
      groupNumber: 'GRP005'
    },
    medicalHistory: ['Anxiety'],
    allergies: ['Ibuprofen'],
    lastVisit: '2024-11-05',
    nextAppointment: '2025-02-05',
    emergencyContact: {
      name: 'David Walsh',
      phone: '+1 (555) 567-8902',
      relationship: 'Husband'
    },
    language: 'en',
    notes: 'Dental anxiety. Prefers sedation for procedures.',
    treatmentPlans: [
      {
        id: 'tp-5',
        title: 'Anxiety Management Protocol',
        description: 'Comprehensive care plan with sedation options for dental anxiety',
        status: 'proposed',
        // caseAcceptanceScore: 72,
        dateCreated: '2024-11-05',
        dateUpdated: '2024-11-05',
        procedures: [
          {
            id: 'proc-9',
            name: 'Oral Sedation Consultation',
            duration: 30,
            priority: 'high'
          },
          {
            id: 'proc-10',
            name: 'Comprehensive Cleaning with Sedation',
            duration: 90,
            priority: 'medium'
          }
        ]
      }
    ],
    smsLogs: [
      {
        id: 'sms-6',
        date: '2025-02-03',
        direction: 'outbound',
        content: 'Reminder: Your sedation appointment is in 2 days. Please follow pre-appointment instructions.',
        status: 'delivered'
      }
    ],
    emailLogs: [
      {
        id: 'email-4',
        date: '2024-11-06',
        direction: 'outbound',
        subject: 'Sedation Pre-Appointment Instructions',
        content: 'Dear Jennifer, please follow these instructions before your sedation appointment...',
        status: 'opened'
      }
    ],
    dentalChart: {
      id: 'chart-5',
      lastUpdated: '2024-11-05',
      notes: 'Patient has severe dental anxiety. Responds well to nitrous oxide. Avoid ibuprofen.',
      teeth: [
        {
          number: '12',
          condition: 'healthy',
          notes: 'Good condition, patient maintains good hygiene despite anxiety',
          lastExamined: '2024-11-05'
        }
      ]
    },
    voiceToChartingNotes: [
      {
        id: 'vtc-4',
        date: '2024-11-05',
        callId: '5',
        transcription: 'Patient very anxious about upcoming procedure, requests sedation options',
        extractedFindings: ['High anxiety level', 'Requests sedation', 'Previous positive experience with nitrous'],
        confidence: 0.87
      }
    ],
    predictiveTreatmentSuggestions: [
      {
        id: 'pts-5',
        suggestion: 'Consider pre-appointment anxiety medication consultation',
        reasoning: 'Patient has documented anxiety disorder and dental phobia',
        confidence: 0.85,
        priority: 'medium',
        dateGenerated: '2024-11-05'
      }
    ],
    educationHistory: [
      {
        id: 'edu-6',
        title: 'Managing Dental Anxiety',
        type: 'video',
        url: 'https://example.com/dental-anxiety-management',
        dateSent: '2024-10-20',
        status: 'viewed',
        viewDuration: 300
      },
      {
        id: 'edu-7',
        title: 'Sedation Options Guide',
        type: 'pdf',
        url: 'https://example.com/sedation-guide.pdf',
        dateSent: '2024-11-06',
        status: 'sent'
      }
    ],
    aiSuggestedMedicalAlerts: [
      {
        id: 'alert-3',
        alert: 'Patient mentioned increased anxiety levels - consider pre-medication',
        source: 'Call transcript analysis',
        confidence: 0.89,
        dateGenerated: '2024-11-05',
        status: 'pending'
      }
    ]
  }
];

// Generate additional patients programmatically
// Add Malorie Down as a specific patient
// dummyPatients.push({
//   id: '56',
//   first_name: 'Malorie Down',
//   phone: '+1 (555) 789-0123',
//   email: 'malorie.down@email.com',
//   dateOfBirth: '1995-07-14',
//   address: '987 Willow Creek Dr, Austin, TX 78706',
//   insurance: {
//     provider: 'Blue Cross Blue Shield',
//     policyNumber: 'BC12345789',
//     groupNumber: 'GRP056'
//   },
//   medicalHistory: [],
//   allergies: [],
//   lastVisit: '',
//   nextAppointment: new Date().toISOString().split('T')[0],
//   emergencyContact: {
//     first_name: 'Sarah Down',
//     phone: '+1 (555) 789-0124',
//     relationship: 'Sister'
//   },
//   language: 'en',
//   notes: 'New patient - first visit scheduled for wisdom teeth consultation and extraction planning.'
// });

// const firstfirst_names = [
//   'Michael', 'Sarah', 'David', 'Lisa', 'Robert', 'Emily', 'John', 'Jessica',
//   'William', 'Ashley', 'Daniel', 'Amanda', 'Christopher', 'Melissa', 'Matthew',
//   'Michelle', 'Anthony', 'Kimberly', 'Mark', 'Donna', 'Steven', 'Carol',
//   'Paul', 'Ruth', 'Andrew', 'Sharon', 'Joshua', 'Laura', 'Kenneth', 'Sarah',
//   'Kevin', 'Cynthia', 'Brian', 'Kathleen', 'George', 'Amy', 'Timothy', 'Angela',
//   'Ronald', 'Brenda', 'Jason', 'Emma', 'Edward', 'Olivia', 'Jeffrey', 'Linda'
// ];

// const lastfirst_names = [
//   'Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis',
//   'Rodriguez', 'Martinez', 'Hernandez', 'Lopez', 'Gonzalez', 'Wilson', 'Anderson',
//   'Thomas', 'Taylor', 'Moore', 'Jackson', 'Martin', 'Lee', 'Perez', 'Thompson',
//   'White', 'Harris', 'Sanchez', 'Clark', 'Ramirez', 'Lewis', 'Robinson',
//   'Walker', 'Young', 'Allen', 'King', 'Wright', 'Scott', 'Torres', 'Nguyen',
//   'Hill', 'Flores', 'Green', 'Adams', 'Nelson', 'Baker', 'Hall', 'Rivera'
// ];

// const insuranceProviders = ['Delta Dental', 'Cigna', 'MetLife', 'Guardian', 'Aetna', 'Blue Cross Blue Shield', 'Humana'];
// const medicalConditions = ['Diabetes Type 2', 'Hypertension', 'Heart Disease', 'Asthma', 'Anxiety', 'Depression', 'High Cholesterol', 'Arthritis'];
// const allergies = ['Penicillin', 'Latex', 'Ibuprofen', 'Codeine', 'Aspirin', 'Sulfa drugs'];

// function generateRandomPatient(id: string): Partial<UserPatient | Patient> {
//   const firstfirst_name = firstfirst_names[Math.floor(Math.random() * firstfirst_names.length)];
//   const lastfirst_name = lastfirst_names[Math.floor(Math.random() * lastfirst_names.length)];
//   const first_name = `${firstfirst_name} ${lastfirst_name}`;
  
//   return {
//     id,
//     first_name,
//     phone: `+1 (555) ${Math.floor(Math.random() * 900 + 100)}-${Math.floor(Math.random() * 9000 + 1000)}`,
//     email: `${firstfirst_name.toLowerCase()}.${lastfirst_name.toLowerCase()}@email.com`,
//     dateOfBirth: `${Math.floor(Math.random() * 30 + 1960)}-${String(Math.floor(Math.random() * 12 + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28 + 1)).padStart(2, '0')}`,
//     address: `${Math.floor(Math.random() * 9999 + 1)} ${['Main St', 'Oak Ave', 'Pine St', 'Cedar Ln', 'Maple Dr', 'Elm St', 'Birch Rd'][Math.floor(Math.random() * 7)]}, Austin, TX 787${String(Math.floor(Math.random() * 10)).padStart(2, '0')}`,
//     insurance: {
//       provider: insuranceProviders[Math.floor(Math.random() * insuranceProviders.length)],
//       policyNumber: `${['DD', 'CG', 'ML', 'GD', 'AE', 'BC', 'HM'][Math.floor(Math.random() * 7)]}${Math.floor(Math.random() * 90000000 + 10000000)}`,
//       groupNumber: `GRP${String(Math.floor(Math.random() * 999 + 1)).padStart(3, '0')}`
//     },
//     medicalHistory: Math.random() > 0.5 ? [medicalConditions[Math.floor(Math.random() * medicalConditions.length)]] : [],
//     allergies: Math.random() > 0.7 ? [allergies[Math.floor(Math.random() * allergies.length)]] : [],
//     lastVisit: `2024-${String(Math.floor(Math.random() * 12 + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28 + 1)).padStart(2, '0')}`,
//     nextAppointment: Math.random() > 0.3 ? `2025-${String(Math.floor(Math.random() * 6 + 1)).padStart(2, '0')}-${String(Math.floor(Math.random() * 28 + 1)).padStart(2, '0')}` : undefined,
//     emergencyContact: {
//       first_name: `${firstfirst_names[Math.floor(Math.random() * firstfirst_names.length)]} ${lastfirst_name}`,
//       phone: `+1 (555) ${Math.floor(Math.random() * 900 + 100)}-${Math.floor(Math.random() * 9000 + 1000)}`,
//       relationship: ['Spouse', 'Parent', 'Child', 'Sibling', 'Friend'][Math.floor(Math.random() * 5)]
//     },
//     language: Math.random() > 0.7 ? 'es' : 'en',
//     notes: [
//       'Prefers morning appointments',
//       'Anxious about dental procedures',
//       'History of teeth grinding',
//       'Uses night guard',
//       'Senior citizen discount applied',
//       'Dental anxiety - prefers sedation',
//       'Healthcare professional',
//       'Requires antibiotic premedication'
//     ][Math.floor(Math.random() * 8)]
//   } as Partial<UserPatient | Patient>;
// }

// Generate additional patients
// for (let i = 6; i <= 55; i++) {
//   const randomPatient = generateRandomPatient(i.toString());
//   // Add minimal data for generated patients
//   randomPatient.treatmentPlans = [];
//   randomPatient.smsLogs = [];
//   randomPatient.emailLogs = [];
//   randomPatient.dentalChart = {
//     id: `chart-${i}`,
//     lastUpdated: '2024-12-01',
//     notes: 'Standard examination completed',
//     teeth: []
//   };
//   randomPatient.voiceToChartingNotes = [];
//   randomPatient.predictiveTreatmentSuggestions = [];
//   randomPatient.educationalHistory = [];
//   randomPatient.aiSuggestedMedicalAlerts = [];
  
//   dummyPatients.push(randomPatient);
// }
